import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, QueryList,SimpleChanges,ViewChildren} from '@angular/core';
import {filter, Subject, Subscription, take, tap} from 'rxjs';
import { ContractStepModel } from '../../../../models/contract.model';
import { TFormState } from '../../../../models/forms.model';
import { IDivStyles, STEPS_COMPONENT_MAP, STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { MatDialog } from '@angular/material/dialog';
import { AppContractStepNameComponent } from '../contract-name-edit-step/contract-step-name-edit.component';
import { CkeditorComponent } from '../../../../components/form/inputs/ckeditor/ckeditor.component';
import { FormControl } from '@angular/forms';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractDataService } from '../../services/contract-data.service';
import { ContractGraphService } from '../../services/contract-graph.service';
import { ContractFormService } from '../../services/contract-form.service';

@Component({
    selector: 'app-contract-step',
    templateUrl: './contract-step.component.html',
    styleUrl: './contract-step.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepComponent {
    private subs:Subscription = new Subscription()
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    @Input() public stepDivData!: IDivStyles;
    @Input() public hidePointer:boolean = false;
    @ViewChildren('step',{read: ElementRef}) stepDiv!:QueryList<ElementRef>
    private POINTER_MARGIN_TOP = 35
    

    public scrollY:number = 0;
    public pointerTop:number =this.POINTER_MARGIN_TOP;
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP
    public StepComponentMap = STEPS_COMPONENT_MAP
    public showCalendar:boolean = false
    public timeFC = new FormControl('')
    public minDate = new Date()
    constructor(
      private contractDataService:ContractDataService,
      private contractFormService:ContractFormService,
      private contractGraphService:ContractGraphService,
      private cds:ChangeDetectorRef,
      private dialog:MatDialog,
    ) { 
    }
    @HostBinding('attr.style')
    public get cssVars() {
      return `
        --pointer-color: ${this.stepsStylingMap.get(this.contractStep?.target_type||'')?.pointerColor};
        --pointer-top: ${this.pointerTop}px;
      `;
    }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.scrollY = window.scrollY
      this.subs.add(this.contractDataService.subContractEdited.asObservable().subscribe(()=>this.cds.detectChanges()))
      this.subs.add(this.contractDataService.subStepPreviewPointerCalc.asObservable().subscribe(()=>this.calcPointerPostition()))
      this.subs.add(this.contractDataService.subStepDataChanged.asObservable().subscribe(()=>this.cds.detectChanges()))
/*       this.subs.add(this.timeFC.valueChanges.subscribe(val=>{
        this.contractStep!.deadline_at = (this.contractStep?.deadline_at?.slice(0,11)||'') + 'T' + val + ':00Z'
        this.contractDataService.subContractEdited.next(true)
      }))
 */
    }
    ngOnChanges(changes:SimpleChanges): void {
      this.stepDivData.stepIsCalculated = false
      this.scrollY = window.scrollY
      this.showCalendar = false
      this.calcPointerPostition()
    }
    calcPointerPostition() {
      setTimeout(() => {
        if (this.stepDiv?.last) {
          this.pointerTop = this.POINTER_MARGIN_TOP
          let stepDivHeight = this.stepDiv.last.nativeElement.offsetHeight
          let toBottom = window.innerHeight - this.stepDivData.top - 66 -96
          let toTop =  this.stepDivData.top - 30
          
          if (toBottom < stepDivHeight && stepDivHeight < toTop) {
            this.stepDivData.top = this.stepDivData.top - stepDivHeight + this.stepDivData.height;
            this.pointerTop = this.pointerTop 
            this.pointerTop = this.pointerTop + stepDivHeight - this.stepDivData.height -this.POINTER_MARGIN_TOP/2
            this.contractDataService.subStepFormCDS.next(true)
            this.stepDivData.stepIsCalculated = true
            this.cds.detectChanges()
          } else {
            this.stepDivData.stepIsCalculated = true
            this.cds.detectChanges()
            this.contractDataService.subStepFormCDS.next(true)
          }
        }
      }, 100);
    }
    openCalendar(){
      if (this.contractData?.rights?.isContractBlockedForEdit === true) {
        return
      }
      this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=> this.showCalendar = !this.showCalendar)
    }
    editStepName() {
      if (this.contractData?.rights?.isContractBlockedForEdit === true) {
        return
      }
      this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{
        let nameEditorRef = this.dialog.open(AppContractStepNameComponent,{
          panelClass:'name-editor-dialog',
          minWidth:'600px'
        })
        let initialName = this.contractStep?.name
        nameEditorRef.componentInstance.contractStep = this.contractStep!
        nameEditorRef.afterClosed()
        .pipe(
          take(1),
          filter(()=>initialName!==this.contractStep?.name)
        )
        .subscribe(()=>{
          let roadmap = this.contractDataService.ContractDataCachedByGuid.get(this.contractData?.contract?.contract?.guid||'')?.contract?.roadmap_active 
          this.contractDataService.subContractEdited.next(true)
          this.contractGraphService.prepareGraph(true,true,this.contractData?.contract?.contract?.guid||'',{},roadmap?.steps)
        })
      })
    }
    deadlineDateChanged(newDate:Date) {
      let day = ('0'+newDate.getDate()).slice(-2)
      let month = ('0'+(newDate.getMonth()+1)).slice(-2)
      this.contractStep!.deadline_at = [newDate.getFullYear(),month, day].join('-')
      this.contractDataService.subContractEdited.next(true)
    }
    openDescriptionEditor () {
      if (this.contractData?.rights?.isContractBlockedForEdit === true) {
       return
      }
      this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{
        let ckEditorRef = this.dialog.open(CkeditorComponent,{
            panelClass:'contract-ckeditor-padding-modalbox',
            minHeight:'50vh',
            minWidth:'50vw'
        })
        ckEditorRef.componentInstance.inputData = this.contractStep!.description||''
        ckEditorRef.componentInstance.isShowEditor = true
        ckEditorRef.componentInstance.emitFinish
        .pipe(
            take(1),
            tap(data=>data[0]? this.contractStep!.description = data[1] : null),
            tap(data=>data[0]? this.contractDataService.subContractEdited.next(true) : null),
            tap(()=>ckEditorRef.close()),
            tap(()=>this.cds.detectChanges()))
        .subscribe()
    })
  }
}